export interface IRole {
    roleCode: string;
    roleId: number;
}
